import { Component, inject, InjectionToken } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Observable, of } from 'rxjs';
import FieldsConstants from 'src/app/common/fields.constants';
import { MessageLevel, SendEmailDialogData } from 'src/app/interfaces/dialog.interface';
import { DialogActionTypes } from 'src/app/notifications/dialogs/dialogs.enum';
import { NotificationState } from 'src/app/notifications/notifications.state';
import { ValidationService } from 'src/app/services/validation.service';

export const DIALOG_SEND_EMAIL_DATA = new InjectionToken<SendEmailDialogData>(`DIALOG_SEND_EMAIL_DATA`);

@Component({
  selector: 'app-dialog-send-reactivation-request',
  templateUrl: './dialog-admin-decline-request.component.html',
  styleUrls: ['./dialog-admin-decline-request.component.scss'],
})
export class DialogAdminDeclineRequestComponent extends NotificationState {
  public readonly confirmActionButton: string = DialogActionTypes.CONFIRM_ACTION;
  public readonly maxReasonLength = FieldsConstants.DECLINE_REACTIVATION_PETITION_MAX_LENGTH;

  public readonly modalArguments = inject(DIALOG_SEND_EMAIL_DATA);
  public readonly hasUnsavedChanges$: Observable<boolean> = of(false);

  protected notificationLevel: MessageLevel = 'INFO';

  public readonly requestDescription: FormControl<string> = new FormControl('', [
    Validators.required,
    Validators.minLength(1),
    Validators.maxLength(this.maxReasonLength),
    ...inject(ValidationService).getValidators('noWhiteSpacesOnly'),
  ]);

  public actionsHandler(action: DialogActionTypes): void {
    this.dialogActions[action]();
  }

  public submit(): void {
    this.confirmAction();
  }

  public override confirmAction(): void {
    if (!this.isValid) {
      return;
    }

    this.activeModal.close(this.requestDescription.value);
  }

  public get isValid(): boolean {
    return this.requestDescription.valid;
  }

  public onBlur(): void {
    this.requestDescription.setValue((this.requestDescription.value || '').trim());
  }
}
